if (typeof window.modalPostcodeChecker === "undefined") {
  window.modalPostcodeChecker = async () => {
    const MODULE_NAME = "Postcode Checker";
    const MODAL_SELECTOR = "#modal-postcode-checker";
    const POSTCODE_CHECKER_ENDPOINT = "https://app.stockmansteaks.com.au/storefront/api/v1/check-postcode";
    const SUBURB_POSTCODE_SUGGESTION_ENDPOINT = "https://aussie-area-checker.sllsolutions.com.au/suggestions";
    const STORAGE_KEY = "stockman_postcode_checker";

    let debounceTimer = null;

    const printLog = (message, extra) => {
      console.log(
        "%c" + MODULE_NAME,
        "font-weight: bold; color: #000; background: #c7facd; border-radius: 3px; padding: 0 5px;",
        message,
        extra || ""
      );
    };

    const validateRequiredScripts = async (timeout = 5000) => {
      const start = Date.now();
      while (true) {
        if (typeof window.jQuery === "function") return;
        if (Date.now() - start >= timeout) {
          printLog("Timeout waiting for jQuery");
          return;
        }
        await new Promise((r) => setTimeout(r, 50));
      }
    };

    const toggleModal = ($el, value) => {
      const $body = $("body");
      const $modal = $el.hasClass("modal-mini")
        ? $el
        : $el.closest(".modal-mini");

      if (value) {
        $modal.fadeIn("fast");
        $body.addClass("modal-mini-active");
      } else {
        $modal.fadeOut("fast");
        $body.removeClass("modal-mini-active");
      }
    };

    const toggleFormLoading = ($form, value) => {
      const $submit = $form.find("[type=submit]");
      const $spinner = $form.find(".loading-overlay__spinner");

      if (!$submit.length || !$spinner.length) return;

      if (value) {
        $submit.addClass("loading").attr("disabled", "disabled");
        $spinner.removeClass("hidden");
      } else {
        $submit.removeClass("loading").removeAttr("disabled");
        $spinner.addClass("hidden");
      }
    };

    const showMessage = (message, isSuccess) => {
      const $message = $("#postcode-checker-message");
      
      if (!$message.length) {
        return;
      }

      if (!message) {
        $message.hide().text("");
        $message.removeClass(
          "postcode-checker--success postcode-checker--error"
        );
        return;
      }

      $message
        .text(message)
        .show()
        .removeClass("postcode-checker--success postcode-checker--error")
        .addClass(
          isSuccess
            ? "postcode-checker--success"
            : "postcode-checker--error"
        );
    };

    const updateCurrentSelectionUI = (selection) => {
      const $el = $("#postcode-checker-current");
      if (!$el.length) return;

      if (!selection) {
        $el.hide().text("");
        return;
      }

      // Suburb/postcode are user-typed (and persisted in localStorage), so never insert them as HTML
      const $strong = $("<strong>").text(`${selection.suburb} ${selection.postcode}`);
      const $box = $('<div class="notification-box notification-box--success">')
        .append("We deliver to ", $strong);

      $el.empty().append($box).show();
    };

    const saveSelection = (suburb, postcode) => {
      try {
        const payload = { suburb, postcode, timestamp: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
        updateCurrentSelectionUI(payload);
      } catch (e) {
        console.error(e);
      }
    };

    const loadSelection = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || !data.suburb || !data.postcode) return null;
        return data;
      } catch (e) {
        console.error(e);
        return null;
      }
    };

    const clearSelection = () => {
      try {
        localStorage.removeItem(STORAGE_KEY);
        updateCurrentSelectionUI(null);
      } catch (e) {
        console.error(e);
      }
    };

    const initFromLocalStorage = () => {
      const saved = loadSelection();
      if (!saved) {
        updateCurrentSelectionUI(null);
        return;
      }

      $("#postcode-checker-suburb").val(saved.suburb);
      $("#postcode-checker-postcode").val(saved.postcode);

      updateCurrentSelectionUI(saved);
    };

    const submitPostcodeForm = ($form) => {
      const suburb = $("#postcode-checker-suburb").val().trim();
      const postcode = $("#postcode-checker-postcode").val().trim();

      console.log({ suburb, postcode });

      if (!suburb || !postcode) {
        showMessage(
          "Please enter a suburb and a valid postcode.",
          false
        );
        return;
      }

      toggleFormLoading($form, true);
      showMessage("", false);

      const url =
        POSTCODE_CHECKER_ENDPOINT +
        "?zip=" +
        encodeURIComponent(postcode) +
        "&city=" +
        encodeURIComponent(suburb);

      clearSelection();

      console.log(url);

      fetch(url, {
        method: "GET",
        headers: { Accept: "application/json" }
      })
        .then((res) => res.json())
        .then((data) => {
          const ok = !!data.status;
          const deliverable = !!data.canBeDelivered;
          const msg =
            data.message ||
            (ok
              ? "Delivery status received."
              : "Unable to check delivery at this time.");

          if (!ok) showMessage(msg, ok && deliverable);

          if (ok && deliverable) {
            saveSelection(suburb, postcode);
          } else if (ok && !deliverable) {
            showMessage("We don't deliver to that suburb & postcode at this time.");
          } else {
            showMessage(data.message || "Unable to check delivery at this time.", false);
          }
        })
        .catch(() => {
          showMessage(
            "Something went wrong while checking your postcode. Please try again.",
            false
          );
        })
        .finally(() => {
          toggleFormLoading($form, false);
        });
    };

    // --- TWO-FIELD KEYBOARD-SUPPORTED SUGGESTION ENGINE ---
    const initCustomAutocomplete = () => {
      const suburbInput = document.getElementById("postcode-checker-suburb");
      const postcodeInput = document.getElementById("postcode-checker-postcode");
      
      if (!suburbInput || !postcodeInput) {
        printLog("One or more input elements missing");
        return;
      }

      let currentFocus = -1;
      let activeInput = null;

      // Single dropdown node shared dynamically between inputs
      const dropdown = document.createElement("ul");
      dropdown.id = "postcode-checker-dropdown";
      dropdown.className = "postcode-autocomplete-dropdown hidden";

      const hideDropdown = () => {
        dropdown.innerHTML = "";
        dropdown.classList.add("hidden");
        currentFocus = -1;
      };

      const selectItem = (item) => {
        suburbInput.value = item.suburb;
        postcodeInput.value = item.postcode;
        hideDropdown();
      };

      const addActive = (items) => {
        if (!items || items.length === 0) return;
        
        removeActive(items);
        
        if (currentFocus >= items.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = items.length - 1;
        
        const activeItem = items[currentFocus];
        activeItem.classList.add("autocomplete-active");
        activeItem.scrollIntoView({ block: "nearest" });
      };

      const removeActive = (items) => {
        for (let i = 0; i < items.length; i++) {
          items[i].classList.remove("autocomplete-active");
        }
      };

      const triggerQuery = (keyword, targetInput) => {
        activeInput = targetInput;
        
        if (keyword.length < 2) {
          hideDropdown();
          return;
        }

        // Dynamically mount the dropdown container strictly under the targeted visible input container
        if (dropdown.parentNode !== targetInput.parentNode) {
          targetInput.parentNode.appendChild(dropdown);
        }

        const url = `${SUBURB_POSTCODE_SUGGESTION_ENDPOINT}?q=${encodeURIComponent(keyword)}`;
        
        fetch(url, {
          method: "GET",
          headers: { 
            Accept: "application/json",
            "X-API-Key": "ak_9c7e1c130bb4cc24bd97d50b6414b888fc1f1396b3ee5453"
          }
        })
          .then((res) => res.json())
          .then((data) => {
            // Robust parsing fallback to support both direct array outputs and nested lists safely
            const list = Array.isArray(data) ? data : (data.data || data.list || data.suggestions || data.results || []);
            
            dropdown.innerHTML = "";
            currentFocus = -1;
            
            if (list.length === 0) {
              hideDropdown();
              return;
            }

            list.forEach((item) => {
              const li = document.createElement("li");
              li.textContent = `${item.suburb}, ${item.state} ${item.postcode}`;
              li.setAttribute("data-item", JSON.stringify(item));
              li.addEventListener("click", () => selectItem(item));
              dropdown.appendChild(li);
            });

            dropdown.classList.remove("hidden");
          })
          .catch((err) => console.error("Error fetching suggestions:", err));
      };

      // Ensure Postcode Input only accepts digits and retains leading zeroes correctly
      postcodeInput.addEventListener("input", (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, "");
      });

      // Bind dynamic suggestion events to both Suburb and Postcode inputs
      [suburbInput, postcodeInput].forEach((inputEl) => {
        // Typing updates
        inputEl.addEventListener("input", (e) => {
          clearTimeout(debounceTimer);
          const keyword = e.target.value.trim();

          debounceTimer = setTimeout(() => {
            triggerQuery(keyword, inputEl);
          }, 250);
        });

        // Click / focus triggers immediate search if closed but characters exist
        ["focus", "click"].forEach(eventType => {
          inputEl.addEventListener(eventType, (e) => {
            clearTimeout(debounceTimer);
            const keyword = e.target.value.trim();
            
            if (dropdown.classList.contains("hidden") && keyword.length >= 2) {
              triggerQuery(keyword, inputEl);
            }
          });
        });

        // Keyboard arrow handling binds
        inputEl.addEventListener("keydown", (e) => {
          let items = dropdown.getElementsByTagName("li");
          if (dropdown.classList.contains("hidden") || items.length === 0) return;

          if (e.keyCode === 40) { // DOWN Arrow
            e.preventDefault();
            currentFocus++;
            addActive(items);
          } else if (e.keyCode === 38) { // UP Arrow
            e.preventDefault();
            currentFocus--;
            addActive(items);
          } else if (e.keyCode === 13) { // ENTER Key
            e.preventDefault();
            if (currentFocus > -1 && items[currentFocus]) {
              const itemDataStr = items[currentFocus].getAttribute("data-item");
              if (itemDataStr) {
                selectItem(JSON.parse(itemDataStr));
              }
            }
          } else if (e.keyCode === 27) { // ESC Key
            hideDropdown();
          }
        });
      });

      // Global touch/click dismiss handler
      document.addEventListener("click", (e) => {
        if (
          !e.target.closest("#postcode-checker-suburb") && 
          !e.target.closest("#postcode-checker-postcode") && 
          !e.target.closest("#postcode-checker-dropdown")
        ) {
          hideDropdown();
        }
      });
    };

    const setupEvents = () => {
      // Submit
      $(document).on("submit", "[data-postcode-checker-form]", function (e) {
        e.preventDefault();
        submitPostcodeForm($(this));
      });

      // Close buttons and overlay
      $(".modal-mini").on("click", "[data-close-modal]", function (e) {
        e.preventDefault();
        toggleModal($(this), false);
      });

      // Open modal
      $(document).on("click", "[data-toggle='postcode-checker']", function (e) {
        e.preventDefault();
        toggleModal($(MODAL_SELECTOR), true);
      });
    };

    await validateRequiredScripts();
    setupEvents();
    initFromLocalStorage();
    initCustomAutocomplete();

    printLog("modal-postcode-checker.js loaded");
  };

  (function () {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        window.modalPostcodeChecker();
      });
    } else {
      window.modalPostcodeChecker();
    }
  })();
}